<template>
  <b-overlay :show="loading">
    <b-form data-vv-scope="bidder-form">
      <b-form-group
        label="Rut"
        label-for="iut"
        class="mb-3"
      >
        <b-form-input-rut
          id="iut"
          name="iut"
          data-cy="bidder-iut"
          placeholder="Rut"
          v-model="bidder.identification"
          :state="errors.has('bidder-form.iut') ? false : null"
          v-validate="'required|validateRut'"
          data-vv-as="Rut"
          :disabled="!!bidder.id"
          truncateValue
        />
        <b-form-invalid-feedback>
          {{ errors.first('bidder-form.iut') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        data-vv-as="Nombre / razón social"
        label="Nombre / razón social"
        label-for="name"
        class="mb-3"
      >
        <b-form-input
          id="name"
          name="name"
          data-cy="bidder-name"
          placeholder="Nombre"
          data-vv-as="Nombre"
          v-model="bidder.name"
          :state="errors.has('bidder-form.name') ? false : null"
          v-validate="'required|max:100'"
        />
        <b-form-invalid-feedback>
          {{ errors.first('bidder-form.name') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <div class="text-right">
        <b-button
          @click="createBidder()"
          variant="primary"
          class="mr-1 text-right"
          data-cy="next-button"
        >
          Guardar
        </b-button>
      </div>
    </b-form>
  </b-overlay>
</template>
<script>
import { mapActions } from 'vuex';

import { successfulBiddersCreate } from '@/febos/servicios/api/aduanas/successfulBidders';
import BFormInputRut from '@/components/inputs/BFormInputRut';

export default {
  components: {
    BFormInputRut
  },
  data() {
    return {
      loading: false,
      bidder: {
        name: '',
        identification: ''
      }
    };
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    async createBidder() {
      const result = await this.$validator.validateAll('bidder-form');
      if (!result) {
        return;
      }
      this.loading = true;
      try {
        const { data } = await successfulBiddersCreate(this.bidder);
        await this.$emit('bidder-save', { ...data, action: 'create' });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
